import {
	getStaffMe,
	refreshStaffSession,
} from "@/features/auth/api/auth-staff";
import {
	applyStaffAccess,
	applyStaffAccount,
	clearSession,
	getAccessToken,
	getRefreshToken,
	isAuthenticated,
} from "@/features/auth/lib/auth-store";

/**
 * Re-read the portal account on boot (`GET /auth/staff/me`). Role and tags
 * live on the row, not in the JWT, so a change lands without signing in again.
 * A dead access token is traded via `POST /auth/staff/refresh` (does not extend
 * the refresh expiry). Anything else clears the session.
 */
export async function hydrateStaffSession(): Promise<boolean> {
	const accessToken = getAccessToken();
	const refreshToken = getRefreshToken();

	if (!accessToken && !refreshToken) {
		return false;
	}

	if (accessToken) {
		try {
			applyStaffAccount(await getStaffMe(accessToken));
			return true;
		} catch {
			// Access lapsed — try the refresh token next.
		}
	}

	if (!refreshToken) {
		clearSession();
		return false;
	}

	try {
		applyStaffAccess(await refreshStaffSession(refreshToken));
		return isAuthenticated();
	} catch {
		clearSession();
		return false;
	}
}
